import React, { useState } from 'react';
import PlayButton from "../../images/gif/play-gif-unscreen.gif";
import Imageone from '../../Video/akt-car-wash-gif/car wash-1.gif';
import Videoone from '../../Video/akt-car-wash-video/car wash one.mp4';

const videoData = [
    {
        id: 1,
        title: 'One',
        videoUrl: Videoone,
        image: Imageone,
    }
];

function Videobox() {
    const [selectedVideo, setSelectedVideo] = useState(null);

    const openModal = (video) => {
        setSelectedVideo(video);
        document.body.style.overflow = 'hidden'; // prevent background scroll
    };

    const closeModal = () => {
        setSelectedVideo(null);
        document.body.style.overflow = 'auto'; // re-enable scroll
    };

    return (
        <div className="py-3 px-4 mb-2">
            {/* Video Thumbnails */}
            <div className="grid grid-cols-1 gap-3">
                {videoData.map((video) => (
                    <div
                        key={video.id}
                        className="relative bg-white rounded-2xl overflow-hidden aspect-video cursor-pointer group"
                        onClick={() => openModal(video)}
                    >
                        <img
                            src={video.image}
                            alt={video.title}
                            className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <img src={PlayButton} alt="Play Button" className="h-20 rounded-full bg-black/45 hover:bg-[#0c2340]" />
                        </div>
                    </div>
                ))}
            </div>

            {/* Video Modal */}
            {selectedVideo && (
                <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-2">
                    <div className="relative w-full max-w-7xl h-[85vh] bg-black rounded-xl overflow-hidden shadow-2xl">
                        <video
                            src={selectedVideo.videoUrl}
                            controls
                            loop
                            autoPlay
                            playsInline
                            controlsList="nodownload noremoteplayback"
                            disablePictureInPicture
                            onContextMenu={(e) => e.preventDefault()}
                            className="w-full h-full object-contain"
                        />
                        <button
                            onClick={closeModal}
                            className="absolute top-3 right-3 text-white bg-red-600 hover:bg-red-700 rounded-full px-4 py-2 text-sm"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Videobox;
